<template>
    <div>
        <div v-if="loading" class="loading-row"></div>

        <div v-else-if="items.length === 0" class="history-empty">{{ $t('userWallet.history.empty') }}</div>

        <div v-else class="transaction-list" aria-live="polite">
            <wallet-activity-item
                v-for="item in items"
                :key="item.id"
                :item="item"
                :currency-symbol="currencySymbol"
            />
        </div>

        <paginate :pagination="pagination" @change-page="$emit('change-page')" />
    </div>
</template>

<script>
    import Paginate from '../../../components/Paginate.vue';
    import WalletActivityItem from './WalletActivityItem.vue';

    export default {
        name: 'WalletActivityList',

        components: {
            Paginate,
            WalletActivityItem,
        },

        props: {
            loading: {type: Boolean, default: false},
            items: {type: Array, default: () => []},
            pagination: {
                type: Object,
                default: () => ({total_pages: 0, current_page: 1, per_page: 20, total: 0}),
            },
            currencySymbol: {type: String, required: true},
        },
    };
</script>
